"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HashAlgorithm = exports.SALT_STRATEGIES = exports.SaltStrategy = void 0;
/**
 * There are multiple ways to incorporate the salt into the overall algorithm.
 * See the individual constant properties for details.
 */
exports.SaltStrategy = {
    /**
     * Each time we hash whatever, we will prepend the salt
     * via string concatenation with the secret, if initial (salt + secret),
     * else with the previous hash (salt + prev).
     */
    prependPerHash: 'prependPerHash',
    /**
     * Each time we hash whatever, we will append the salt
     * via string concatenation with the secret, if initial (secret + salt),
     * else with the previous hash (prev + salt).
     */
    appendPerHash: 'appendPerHash',
    /**
     * We will only prepend the salt to the secret (salt + secret) via
     * string concatenation in the initial recusions hash phase.
     */
    initialPrepend: 'initialPrepend',
    /**
     * We will only append the salt to the secret (secret + salt) via
     * string concatenation in the initial recusions hash phase.
     */
    initialAppend: 'initialAppend',
};
exports.SALT_STRATEGIES = Object.values(exports.SaltStrategy);
exports.HashAlgorithm = {
    'sha_256': 'SHA-256',
    'sha_512': 'SHA-512',
};
// export interface EncodeArg {
//     /**
//      * This data conceivable contains all sorts of non-hex characters
//      * like symbols (e.g., _.,\/!?:...) and who knows what.
//      */
//     unencodedData: string;
// }
// export interface EncodeResult {
//     /**
//      * This should only contain characters 0-9 and a-z
//      */
//     encodedData: string;
//     errors: string[];
//     warnings: string[];
// }
